import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { GetSuppliersParams, SupplierResponse, getSuppliers } from '@apis/supplier';
import { dropEmptyValues } from '../../utils/common';

/**
 * useSupplierList
 * - Fetches paginated supplier list
 * - IMPORTANT: queryKey must include normalized search params
 *   so that filter changes trigger refetch without requiring manual refetch or page reload.
 */
export const useSupplierList = ({ page, searchParam }: { page: number; searchParam: GetSuppliersParams }) => {
  // Normalize + stabilize search params for both API request and queryKey.
  const normalized = dropEmptyValues(searchParam, ['supplierName', 'managerName', 'email', 'phoneNumber']);

  // Stable cache key (avoid object identity issues in queryKey).
  const searchKey = JSON.stringify(normalized ?? {});

  const queryOptions: UseQueryOptions<PageResponse<SupplierResponse>, Error> = {
    queryKey: ['suppliers', page, searchKey],
    queryFn: () => {
      return getSuppliers({
        pageNo: page,
        pageSize: 50,
        ...normalized,
      });
    },
    refetchOnMount: 'always',
  };

  return useQuery(queryOptions);
};
